// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************

const GET_FINANCIAL_GUARDIAN_SUCCESS = 'GET_FINANCIAL_GUARDIAN_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getFileSuccess(payload) {
//  console.log(payload);
  return {
    type: GET_FINANCIAL_GUARDIAN_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function checkFile(data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('Guardian')) {
      api.post('/financial/guardian/check_file', {data: {props: data}, params})
        .then((res) => {
          dispatch(_getFileSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.guardian', 'guardian')} - ${app.translate('routes.home.basic.permission.index', 'index')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  guardian: {},
}, action) {
  switch (action.type) {
    case GET_FINANCIAL_GUARDIAN_SUCCESS:
      return Object.assign({}, state, {
        guardian: action.payload.guardian,
      });
    default:
      return state;
  }
}
